import Page from '../../components/page/page'
import { ListLayoutProps } from './list-layout.types'
import { Box } from '@vapor/material'

export default function ListLayout(props: ListLayoutProps) {
  const { title, rightItems, children, id } = props
  return (
    <Page title={title} id={id} rightItems={rightItems} headerBack={props.back} fullWidth={props.fullWidth} hideHeader={props.hideHeader}>
      <Box sx={{ p: 1, px: { lg: 2, xl: 0 }, pb: '20px' }}>{children}</Box>
    </Page>
  )
}
